// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#send-family-safety-confirm-tab[data-v-f2ea3fc6]{position:relative}#send-family-safety-confirm-tab .cancel-btn[data-v-f2ea3fc6],#send-family-safety-confirm-tab .sned-message-btn[data-v-f2ea3fc6]{width:120px}#send-family-safety-confirm-tab .box-footer[data-v-f2ea3fc6]{padding:10px 0 0 0!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
